/**
 * LacedUpChicago — Theme Foundation JS
 *
 * This file is intentionally minimal. It does not contain feature logic
 * (cart, search, drawers, etc.) — each feature ships its own module and
 * initializes itself using the conventions below.
 *
 * Shopify Theme Editor lifecycle:
 * Sections can be added, removed, and re-rendered without a full page
 * load while a merchant is editing. Components that only initialize on
 * `DOMContentLoaded` will silently stop working after a section reload.
 * Use `theme.onSectionLoad(selector, init)` below so interactive
 * components initialize both on first load and after Theme Editor
 * section reloads.
 */

window.theme = window.theme || {};

/**
 * Registers `init(sectionElement)` to run for every element matching
 * `selector` that is currently on the page, and again for any matching
 * element inside a section Shopify re-renders in the Theme Editor.
 */
window.theme.onSectionLoad = function onSectionLoad(selector, init) {
  document.querySelectorAll(selector).forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target.matches(selector)) {
      init(target);
    } else {
      target.querySelectorAll(selector).forEach(init);
    }
  });
};
